export default __webpack_public_path__ + "static/media/warning--severe-weather--g1.84f2d524.png";